import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Impact',
  props: {
    title: null,
    subtitle: null,
    icon: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})